<template>
    <node-view-wrapper class="sezar-parameter-validated-attribute" :class="{ active }" :contenteditable="false">
        <a-popover v-model="active" trigger="click" placement="left" :overlayClassName="'no-padding'">
            <div slot="content" class="sezar-parameter-validated-attribute-popover">
                <ParameterValidationForm
                    :attribute-name="node.attrs.attributeName"
                    :validation-type="node.attrs.validationType"
                    :on-changed="onChanged"
                    :on-cancel="() => (active = false)"
                    :omit="getOmitValidation()"
                />
            </div>

            <span @click="active = true" class="pop-content">
                <AttributeIconPreview :attribute="node.attrs.attributeName" />
                {{
                    `${node.attrs.attributeName}`.startsWith("akinon_") || Attributes.includes(node.attrs.attributeName)
                        ? $t(`chatbotv2.attr.${node.attrs.attributeName}`)
                        : Entities.includes(node.attrs.attributeName)
                        ? $t(`chatbotv2.${node.attrs.attributeName}`)
                        : node.attrs.attributeName
                }}
            </span>
        </a-popover>
    </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";
import log2 from "../../../../../../../utils/log2";
import AttributePicker from "../../pickers/AttributePicker";
import SYSTEM_PUBSUB from "../../../../../../../utils/systemPubSub";
import AttributeIconPreview from "../AttributeIconPreview";
import ParameterValidationForm from "./ParameterValidationForm";
import { Attributes, Entities } from "../../../../palatteEnums";

const log = log2("SezarParameterValidatedAttribute");
export default {
    name: "SezarParameterValidatedAttribute",
    props: nodeViewProps,
    components: {
        NodeViewWrapper,
        AttributePicker,
        AttributeIconPreview,
        ParameterValidationForm,
    },
    data() {
        return {
            active: false,
            Attributes,
            Entities,
        };
    },
    methods: {
        onChanged({ attributeName, validationType }) {
            log("onChanged", { attributeName, validationType });
            this.active = false;
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_ATTRIBUTE_CHANGED, {
                attributeId: this.node.attrs["data-id"],
                attributeName,
                validationType,
            });
        },
        getContent() {
            const attributeName = this.node.attrs.attributeName;
            if (attributeName === "akinon_order_id") return "Order ID";
            else return attributeName;
        },
        getOmitValidation() {
            return this.node.attrs.omitValidation.split(",");
        },
    },
    mounted() {
        this.subscriber = SYSTEM_PUBSUB.stream.subscribe(({ type, payload }) => {
            if (
                type === SYSTEM_PUBSUB.MESSAGE_TYPES.CB_SHOW_ATTRIBUTE_MODAL &&
                payload.attributeId === this.node.attrs["data-id"]
            ) {
                log("CB_SHOW_ATTRIBUTE_MODAL event received", payload);
                this.active = true;
            }
        });
    },
    beforeDestroy() {
        this.subscriber.unsubscribe();
    },
};
</script>

<style scoped lang="scss">
.pop-content {
    gap: 2px;
    height: 18px;
    display: inline-flex;

    .material-icons {
        font-size: 15px;
        padding-top: 2px;
        text-align: center;
    }
}

.sezar-parameter-validated-attribute {
    display: inline-flex;
    background: #ffdc66;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    border-radius: 10px;
    box-decoration-break: clone;
    padding: 2px 5px;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-weight: 700;
    letter-spacing: 1.2px;
    gap: 6px;
    user-select: none;

    &.active {
        background: #006cff;
        cursor: pointer;
        color: #fff;
    }
}
</style>
